import React from "react";
import { getCardImage } from "../resultVisuals/cardAssets";

/**
 * Reference result body for Trio / V-Trio (CasinoResult "trio" / "vtrio" branch):
 *   .row.row5.worli-result > .col-12.col-lg-7 (3 cards) + .col-12.col-lg-5 (.casino-result-desc)
 * rdesc "session#124/JQK#red/black#odd/even#pattern" → the five desc rows.
 */
export default function TrioResultBody({ t1 }) {
  const cards = t1?.card ? String(t1.card).split(",") : [];
  const desc = t1?.rdesc ? String(t1.rdesc).split("#") : [];
  const rows = [
    ["Session (21)", desc[0]],
    ["1 2 4 / J Q K", desc[1]],
    ["Red/Black", desc[2]],
    ["Odd/Even", desc[3]],
    ["Pattern", desc[4]],
  ];

  return (
    <div className="row row5 worli-result">
      {cards.length > 0 && (
        <div className="col-12 col-lg-7">
          <div className="casino-result-content">
            <div className="casino-result-content-item text-center w-100">
              <div className="casino-result-cards">
                {[0, 1, 2].map((i) => (
                  <React.Fragment key={i}>
                    {i > 0 && " "}
                    <div className="casino-result-cards-item">
                      <img src={getCardImage(cards[i])} alt="" />
                    </div>
                  </React.Fragment>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}{" "}
      <div className="col-12 col-lg-5">
        {desc.length > 0 && (
          <div className="casino-result-desc">
            {rows.map(([label, value], i) => (
              <React.Fragment key={label}>
                {i > 0 && " "}
                <div className="casino-result-desc-item">
                  <div>{label}</div> <div>{value}</div>
                </div>
              </React.Fragment>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
